import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegularOpeningHours } from '../../../state-management/model/interfaces/state.model';
import { WebsiteStateService } from '../../../state-management/services/website-state.service';

@Component({
    selector: 'app-opening-hours',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './opening-hours.component.html',
    styleUrl: './opening-hours.component.scss'
})
export class OpeningHoursComponent {

  public readonly classes = input<string>('custom-body-medium');
  public configuration = this.websiteState.configuration;

  constructor(private websiteState: WebsiteStateService) { }
}
